import { SessionData, SessionDataProvider } from "@amzn/awsconsole-web-utils";
import { DEFAULT_DOMAIN_ESC, ESC_REGIONS } from "./constants/cookie-constants";

const DOMAINS = {
    NONPROD: /alpha|beta|gamma|integ|preprod|pre-prod|aws-dev|local/i,
    PROD: /aws.amazon.com|amazonaws.cn|amazonaws-us-gov.com|aws.com|amazonaws.eu/i
};

export function update<T>(target: T, source: Partial<T>): T {
    Object.keys(source).forEach(k => {
        target[k] = source[k];
    });
    return target;
}

/**
 * Takes in a NodeList and returns an array so that regular array methods can be used on it;
 * primarily used for IE11 compatibility
 * @param {NodeList} nodeList - The list to be converted to an array
 */
export function convertToArray(nodeList: NodeList): Array<HTMLElement> {
    return Array.prototype.slice.call(nodeList);
}


/**
 * 
 * @returns true if the current environment is production console, false otherwise.
 */
export const isProdConsole = (): boolean => {
    const hostname = window.location.hostname;
    return DOMAINS.PROD.test(hostname) && !DOMAINS.NONPROD.test(hostname);
};


/**
 * 
 * @returns A promise that resolves to true if the user is in a console session, false if not.
 */
export const isConsoleSession = async (): Promise<boolean> => {
    const sessionData = await getSessionData();
    return !!sessionData;
};

/**
 * 
 * @returns A promise that resolves to the session data if it exists, undefined if not or if an error occurs.
 */
export const getSessionData = async (): Promise<SessionData | undefined> => {
    try {
        return await SessionDataProvider.getInstance()?.getSessionData();
    } catch (error) {
        console.error('Failed to get session data:', error);
        return undefined;
    }
}

/**
 *
 * @returns A promise that resolves to the region of the current session.
 */
export const getRegion = async (): Promise<string | undefined> => {
    const sessionData = await getSessionData();
    const infrastructureRegion = sessionData?.infrastructureRegion ? sessionData.infrastructureRegion : undefined;
    return infrastructureRegion;
}

export const isHostnameInESCDomain = (): boolean => {
    return window.location.hostname.endsWith(DEFAULT_DOMAIN_ESC);
}

export const isRegionInESCPartition = async (): Promise<boolean> => {
    const region = await getRegion();
    return !!(region && ESC_REGIONS.includes(region));
}

export const isESCPartition = async (): Promise<boolean> => {
    return isHostnameInESCDomain() || await isRegionInESCPartition();
}